import { render, staticRenderFns } from "./AlterarMunicipio.vue?vue&type=template&id=7ac2d040&scoped=true"
import script from "./AlterarMunicipio.vue?vue&type=script&lang=js"
export * from "./AlterarMunicipio.vue?vue&type=script&lang=js"
import style0 from "./AlterarMunicipio.vue?vue&type=style&index=0&id=7ac2d040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac2d040",
  null
  
)

export default component.exports